export default __webpack_public_path__ + "7cf120de2b254a44ff6641cee1a74028.svg";